<template>
    <div class="help">
        <div class="header">
            <div class="close" @click="back">
                <img src="@/assets/img/close.svg">
            </div>
            <div class="title">
                遇到問題？
            </div>
        </div>
        <div class="body">
            <div class="order">
                <div class="address">
                    {{ address }}
                </div>
                <div class="info">
                    任務#{{ orderId }} <span>{{ status }}</span>
                </div>
            </div>
            <div class="list">
                <div class="title">
                    請問您遇到什麼問題？
                </div>
                <div class="item" @click="goToChat">
                    <div class="question">
                        任務相關問題
                    </div>
                    <div class="button">
                        聯絡客服
                    </div>
                </div>
                <div class="item" @click="cancel">
                    <div class="question">
                        取消任務
                    </div>
                    <div class="button">
                        <img src="@/assets/img/next-green.svg">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { getOrder } from '../apis';

    export default {
        name: "Help",
        data() {
          return {
              orderId: 0,
              order: {
                  id: 0,
              }
          }
        },
        computed: {
            address() {
                if (!this.order.locations || this.order.locations.length === 0) {
                    return '未知';
                }

                return this.order.locations[0].district + this.order.locations[0].road + ' ' + this.order.locations[0].additional;
            },
            status() {
                let str = '未知狀態';

                switch (this.order.status) {
                    case 'missing':
                        str = '暫停中';
                        break;
                    case 'sending':
                    case 'appointing':
                    case 'dispatching':
                        str = '配對中';
                        break;
                    case 'processing':
                        str = '執行中';
                        break;
                    case 'done':
                    case 'revoke':
                    case 'cancel':
                        str = '已結束';
                        break;
                }

                return str;
            }
        },
        methods: {
            goToChat() {
                window.open('https://line.me/R/ti/p/%40hjc7084c', "_blank");
            },
            cancel() {
                this.$router.replace({
                    name: 'orderEdit',
                    params: {
                        id: this.orderId
                    },
                })
            },
            back() {
                if (window.history.length > 2) {
                    this.$router.go(-1);
                } else {
                    this.$router.push({
                        name: 'home',
                    });
                }
            }
        },
        created() {
            this.orderId = this.$route.params.id;
            getOrder(this.orderId).then((res) => {
               this.order = res.data;
            });
        }
    }
</script>

<style  lang="scss" scoped>
    .help {
        .header {
            padding: 15px;
            position: relative;

            .title {
                height: 22px;
                color: rgba(0,0,0,1);
                font-size: 14px;
                font-weight: 600;
                letter-spacing: -0.34px;
                line-height: 22px;
                text-align: center;
            }

            .close {
                width: 20px;
                height: 20px;
                position: absolute;
                left: 10px;
                cursor: pointer;
                user-select: none;
            }
        }

        .body {
            padding: 15px;

            .order {
                background-color: #4A4A4A;
                box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
                border-radius: 5px;
                color: #FFFFFF;
                font-size: 14px;
                padding: 15px;
                text-align: left;

                .info {
                    margin-top: 5px;

                    span {
                        margin-right: 10px;
                        color: #4FE34F;
                    }
                }
            }

            .list {
                margin: 25px 10px;
                text-align: left;

                .title {
                    margin: 15px 0;
                    font-size: 18px;
                    font-weight: 600;
                }

                .item {
                    padding: 12px 0;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: solid 1px #dddddd;
                    cursor: pointer;
                    user-select: none;
                    font-size: 14px;
                    color: #4a4a4a;

                    .button {
                        color: #339933;
                    }
                }
            }
        }
    }
</style>